import find from "lodash/find";
import get from "lodash/get";
import React from "react";
import { withTranslation } from "react-i18next";
import submit from "submit-form";
import { RillContext } from "../../rill/RillReact/share/base";
import { getExerciseNamesList } from "../../utils/progression-filters";
import Modal from "../modal-new";
import CustomFilters from "./duplicate-workout-components/CustomFilters";
import DuplicateModalFooter from "./duplicate-workout-components/DuplicateModalFooter";
import LoadProgression from "./duplicate-workout-components/LoadProgression";
// Added for optimization tweaks, so as to not have as many arrow functions in render
import ProgressionCheckbox from "./duplicate-workout-components/ProgressionCheckbox";
import ProgressionInput from "./duplicate-workout-components/ProgressionInput";

class ProgressionModal extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      progressions: {},
      checkedProgression: {
        loadProgression: false,
        rpeProgression: false,
        repsProgression: false,
        setsProgression: false,
      },
      checkedFilters: {
        allFilter: true,
        primaryFilter: false,
        secondaryFilter: false,
        assistantFilter: false,
        customFilter: [],
      },
      loadSwitch: {
        percent: true,
        units: context.locals.activeUser.units === "imperial" ? "lb" : "kg",
      },
      viewFilters: false,
    };

    if (get(context.locals, "query.type", "") === "exercise")
      this.exercise = find(context.locals.editExercises, {
        _id: get(context.locals, "query.exerciseId", ""),
      });

    this.exercisesList = getExerciseNamesList(
      context.locals.editExercises || context.locals.activeExercises,
      context.locals.query
    );

    this.handleCheck = this.handleCheck.bind(this);
    this.handleFilters = this.handleFilters.bind(this);
    this.handleProgressionInput = this.handleProgressionInput.bind(this);
    this.handleProgression = this.handleProgression.bind(this);
    this.handleLoadSwitch = this.handleLoadSwitch.bind(this);
    this.updateCustomFilter = this.updateCustomFilter.bind(this);
    this.handleClearAll = this.handleClearAll.bind(this);
  }

  handleProgression(e) {
    e.preventDefault();
    const { progressions, checkedFilters, loadSwitch } = this.state;
    const progression = {
      progressionLoad: progressions.progression_load,
      progressionRpe: progressions.progression_rpe,
      progressionSets: progressions.progression_sets,
      progressionReps: progressions.progression_reps,
      progressionFilters: checkedFilters,
      loadSwitch,
    };

    if (get(this.context.locals, "query.type", "") === "exercise") {
      const { editExercises, activeExercises } = this.context.locals;
      const originalExercise = find(activeExercises || editExercises, {
        _id: get(this.context.locals, "query.exerciseId", ""),
      });

      submit("/actions/exercise/update-progression-to-exercise", {
        method: "POST",
        body: {
          exerciseId: originalExercise._id,
          cycleId: originalExercise.cycle.id,
          program: originalExercise.cycle.program,
          progression,
          user: this.context.locals.activeUserToRequest._id,
        },
      });
    } else if (get(this.context.locals, "query.type", "") === "workout") {
      const { cycle, session, program, week } = this.context.locals.query;

      submit("/actions/exercise/update-progression-to-session", {
        method: "POST",
        body: {
          cycleId: cycle,
          program,
          session,
          week,
          progression,
          user: this.context.locals.activeUserToRequest._id,
        },
      });
    } else if (get(this.context.locals, "query.type", "") === "week") {
      const { cycle, program, week } = this.context.locals.query;

      let body = {
        cycleId: cycle,
        program,
        week,
        progression,
      };

      if (this.context.locals.activeUser.organizationId) {
        body = { ...body, user: this.context.locals.activeUserToRequest._id };
      }

      submit("/actions/exercise/update-progression-to-week", {
        method: "POST",
        body,
      });
    } else if (get(this.context.locals, "query.type", "") === "calendar-week") {
      const from = get(this.context.locals, "query.day", "");
      const athlete = get(this.context.locals, "query.athlete", "");
      submit("/actions/exercise/update-progression-to-week?calendarMode=true", {
        method: "POST",
        body: {
          from,
          progression,
          athlete,
        },
      });
    }
  }

  handleProgressionInput({ target: { name, value } }) {
    const {
      locals: { activeUserToRequest },
    } = this.context;
    const intensityMeasure = get(
      activeUserToRequest,
      "intensityMeasure",
      "rpe"
    );
    const progressions = { ...this.state.progressions };
    progressions[name] = Number(value);
    if (name.includes("rpe") && intensityMeasure === "rir") {
      progressions[name] = progressions[name] * -1;
    }
    this.setState({ progressions });
  }

  handleCheck({ target: { name, checked } }) {
    this.setState((prevState) => {
      const checkedProgression = {
        ...prevState.checkedProgression,
      };
      checkedProgression[name] = checked;
      return { checkedProgression };
    });
  }

  handleFilters({ target: { name, checked } }) {
    if (name === "allFilter") {
      this.setState({
        checkedFilters: {
          allFilter: true,
          primaryFilter: false,
          secondaryFilter: false,
          assistantFilter: false,
          customFilter: [],
        },
      });
    } else if (name === "customFilter") {
      this.setState({
        viewFilters: true,
      });
    } else {
      this.setState((prevState) => {
        const checkedFilters = { ...prevState.checkedFilters };
        checkedFilters.allFilter = false;
        checkedFilters.customFilter = [];
        checkedFilters[name] = checked;
        return { checkedFilters };
      });
    }
  }

  updateCustomFilter(action, data) {
    switch (action) {
      case "check":
        // Custom filter checkbox checked, update array
        return this.setState((prevState) => {
          const checkedFilters = {
            ...prevState.checkedFilters,
            customFilter: data,
          };
          return { checkedFilters };
        });
      case "discard":
        // "Discard", viewFilters off and clear customFilter
        return this.setState((prevState) => {
          const checkedFilters = {
            ...prevState.checkedFilters,
            customFilter: [],
          };
          return { checkedFilters, viewFilters: false };
        });
      default:
        // "Save" case, viewFilters off, all filters off except customFilter
        return this.setState((prevState) => {
          const checkedFilters = {
            ...prevState.checkedFilters,
            allFilter: false,
            primaryFilter: false,
            secondaryFilter: false,
            assistantFilter: false,
          };
          return { checkedFilters, viewFilters: false };
        });
    }
  }

  handleLoadSwitch(e) {
    e.preventDefault();

    this.setState(({ loadSwitch }) => ({
      loadSwitch: { ...loadSwitch, percent: !loadSwitch.percent },
    }));
  }

  handleClearAll(e) {
    e.preventDefault();
    this.setState({
      progressions: {},
      checkedProgression: {
        loadProgression: false,
        rpeProgression: false,
        repsProgression: false,
        setsProgression: false,
      },
      checkedFilters: {
        allFilter: true,
        primaryFilter: false,
        secondaryFilter: false,
        assistantFilter: false,
        customFilter: [],
      },
    });
    document.getElementById("progression-form")?.reset?.();
  }

  render() {
    const { t } = this.props;
    const {
      locals: { query, activeUserToRequest },
    } = this.context;
    const { checkedProgression, checkedFilters, loadSwitch, progressions } =
      this.state;
    const {
      loadProgression,
      rpeProgression,
      setsProgression,
      repsProgression,
    } = checkedProgression;
    const {
      allFilter,
      primaryFilter,
      secondaryFilter,
      assistantFilter,
      customFilter,
    } = checkedFilters;

    const isExercise = get(query, "type", "") === "exercise";
    let exType;
    if (isExercise) {
      const { type } = this.exercise;
      exType = type;
    }

    const intensityMeasureRaw = get(
      activeUserToRequest,
      "intensityMeasure",
      "rpe"
    );
    const intensityMeasure = intensityMeasureRaw === "rpe" ? "RPE" : "RiR";

    const loadLabel = loadSwitch.percent ? "%" : loadSwitch.units;
    const disabledProgression =
      !loadProgression &&
      !rpeProgression &&
      !repsProgression &&
      !setsProgression;

    if (this.state.viewFilters) {
      return (
        <CustomFilters
          exercises={this.exercisesList}
          customFilter={customFilter}
          updateCustomFilter={this.updateCustomFilter}
        />
      );
    }

    return (
      <form
        onSubmit={this.handleProgression}
        data-noreset
        id="progression-form"
      >
        <Modal
          className={"progression-modal"}
          toClear={["session", "week"]}
          title={t("progression.title")}
        >
          <div className="body">
            <div className="progression-toggle">
              {exType !== "assistant" &&
                (!assistantFilter || secondaryFilter || primaryFilter) && (
                  <LoadProgression
                    handleCheck={this.handleCheck}
                    handleLoadSwitch={this.handleLoadSwitch}
                    loadSwitch={loadSwitch}
                    checked={loadProgression}
                  />
                )}

              <ProgressionCheckbox
                name="repsProgression"
                onChange={this.handleCheck}
                checked={repsProgression}
              >
                {t("duplicateWorkout.addProgressionsToReps")}
              </ProgressionCheckbox>

              <ProgressionCheckbox
                name="rpeProgression"
                onChange={this.handleCheck}
                checked={rpeProgression}
              >
                {t("duplicateWorkout.addProgressionsToIntensity", {
                  intensityMeasure,
                })}
              </ProgressionCheckbox>

              <ProgressionCheckbox
                name="setsProgression"
                onChange={this.handleCheck}
                checked={setsProgression}
              >
                {t("duplicateWorkout.addProgressionsToSets")}
              </ProgressionCheckbox>
            </div>
            {!isExercise && (
              <div
                className={`progression-filter${
                  disabledProgression ? " opacity-30" : ""
                }`}
              >
                <span>{t("duplicateWorkout.exerciseTypeProgressionFilter")}</span>
                <ul>
                  <ProgressionCheckbox
                    name="allFilter"
                    checked={allFilter}
                    onChange={this.handleFilters}
                    disabled={disabledProgression}
                  >
                    {t("duplicateWorkout.all")}
                  </ProgressionCheckbox>
                  <ProgressionCheckbox
                    name="primaryFilter"
                    checked={primaryFilter}
                    onChange={this.handleFilters}
                    disabled={disabledProgression}
                  >
                    {t("duplicateWorkout.primaryLift")}
                  </ProgressionCheckbox>
                  <ProgressionCheckbox
                    name="secondaryFilter"
                    checked={secondaryFilter}
                    onChange={this.handleFilters}
                    disabled={disabledProgression}
                  >
                    {t("duplicateWorkout.variations")}
                  </ProgressionCheckbox>
                  <ProgressionCheckbox
                    name="assistantFilter"
                    checked={assistantFilter}
                    onChange={this.handleFilters}
                    disabled={disabledProgression}
                  >
                    {t("duplicateWorkout.accessories")}
                  </ProgressionCheckbox>
                  <ProgressionCheckbox
                    name="customFilter"
                    checked={customFilter.length > 0}
                    onChange={this.handleFilters}
                    disabled={disabledProgression}
                  >
                    {t("duplicateWorkout.customFilterCount", {
                      count: customFilter.length,
                    })}
                  </ProgressionCheckbox>
                </ul>
              </div>
            )}

            {!disabledProgression && (
              <div className="progressions-wrapper">
                <div className="progression-workout">
                  {(!assistantFilter || secondaryFilter || primaryFilter) && (
                    <p className={`p2 ${loadProgression}`}>
                      {t("duplicateWorkout.loadLabel", { loadLabel })}{" "}
                    </p>
                  )}
                  <p className={`p2 ${rpeProgression}`}>
                    {t("duplicateWorkout.intensityIncr", {
                      intensityMeasure,
                    })}
                  </p>
                  <p className={`p2 ${repsProgression}`}>
                    {t("duplicateWorkout.reps")}
                  </p>
                  <p className={`p2 ${setsProgression}`}>
                    {t("duplicateWorkout.sets")}
                  </p>
                </div>

                <div className="progression-inputs">
                  {exType !== "assistant" &&
                    (!assistantFilter || secondaryFilter || primaryFilter) && (
                      <ProgressionInput
                        step="0.5"
                        placeholder={t("duplicateWorkout.loadPlaceholder", {
                          loadLabel,
                        })}
                        name={`progression_load`}
                        onInput={this.handleProgressionInput}
                        progressions={progressions}
                        unchecked={!loadProgression}
                      />
                    )}

                  <ProgressionInput
                    name={`progression_rpe`}
                    onInput={this.handleProgressionInput}
                    isRpe
                    progressions={progressions}
                    unchecked={!rpeProgression}
                    intensityMeasure={intensityMeasureRaw}
                  />

                  <ProgressionInput
                    step="1"
                    placeholder={t("duplicateWorkout.reps")}
                    name={`progression_reps`}
                    onInput={this.handleProgressionInput}
                    progressions={progressions}
                    unchecked={!repsProgression}
                  />

                  <ProgressionInput
                    step="1"
                    placeholder={t("duplicateWorkout.sets")}
                    name={`progression_sets`}
                    onInput={this.handleProgressionInput}
                    progressions={progressions}
                    unchecked={!setsProgression}
                  />
                </div>
              </div>
            )}
          </div>

          <DuplicateModalFooter
            btnText={t("progression.progress")}
            onClear={this.handleClearAll}
          />
        </Modal>
      </form>
    );
  }
}

ProgressionModal.contextType = RillContext;

export default withTranslation("coaching-portal")(ProgressionModal);
